export default "__VITE_ASSET__IVPVjqYV__";